export default function ProductShowcase() {
  return (
    <section id="product" className="w-full bg-background-50 py-14 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center" data-product-shop>
          <div className="order-2 lg:order-1">
            <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
              FLAGSHIP · X9 PRO
            </span>
            <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
              라이더의 감각을<br />다시 정의하는, 단 하나의 장비
            </h2>
            <p className="mt-6 text-foreground-700 text-base leading-relaxed max-w-lg">
              X9 PRO는 조용한 몰입, 정확한 통화, 흔들림 없는 연결을 위해 설계된
              프리미엄 헬멧 블루투스 통신 장비입니다. 라이더가 필요한 것만 남기고,
              모든 것을 다시 만들었습니다.
            </p>

            <dl className="mt-10 grid grid-cols-3 gap-4">
              {[
                { k: "5.4", v: "블루투스", icon: "ri-bluetooth-line" },
                { k: "15h", v: "연속 통화", icon: "ri-phone-line" },
                { k: "IP67", v: "방수·방진", icon: "ri-drop-line" },
              ].map((it) => (
                <div
                  key={it.k}
                  className="min-w-0 rounded-lg bg-background-100 border border-background-200/70 px-2 sm:px-4 py-5 text-center sm:text-left"
                >
                  <i
                    className={`${it.icon} mb-2 inline-block text-xl text-primary-500`}
                    aria-hidden="true"
                  ></i>
                  <dt className="font-heading text-xl sm:text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap">
                    {it.k}
                  </dt>
                  <dd className="mt-1 text-[11px] md:text-xs text-foreground-600 tracking-tight md:tracking-wide whitespace-nowrap">
                    {it.v}
                  </dd>
                </div>
              ))}
            </dl>

              <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-3">
                <a
                  href="#features"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector("#features")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="inline-flex w-[170px] justify-center items-center gap-2 rounded-md bg-foreground-950 hover:bg-foreground-800 text-background-50 px-6 py-3 text-sm font-semibold cursor-pointer whitespace-nowrap transition-colors"
                >
                  X9 PRO 상세보기
                  <i className="ri-arrow-down-line"></i>
                </a>
              <a
                href="#buy"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#buy")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex w-[170px] justify-center items-center gap-2 rounded-md border border-primary-500 bg-primary-500 hover:bg-primary-600 hover:border-primary-600 text-background-50 px-6 py-3 text-sm font-bold cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/20 transition-all"
              >
                <i className="ri-store-2-line"></i>
                공식판매점
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-square">
              <img
                src={`${__BASE_PATH__}images/x9pro-product-main.jpg`}
                alt="X9 PRO 제품 이미지"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute bottom-6 left-6 flex items-center gap-2 px-3 py-1.5 rounded-full bg-foreground-950 text-background-50 text-xs font-semibold tracking-widest">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                NEW · 2026
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
